<div class="account-side-bar-menu">
  <ng-container *ngFor="let items of profileListing">
    <div class="account-side-bar-menu__block">
      <h3 class="account-side-bar-menu__title" data-hj-suppress>{{ items?.title }}</h3>

      <ng-container *ngFor="let item of items.menuItems">
        <ng-container *ngIf="!item.menuItem;">
          <a *ngIf="!item.disabled"
            class="account-side-bar-menu-item"
            [href]="item.link"
            (click)="handleCSSLinks($event, item.link, item?.gaEventLabel)"
            [class.account-side-bar-menu-item--active]="item?.link === navigatedUrl"
            [mmTestTarget]="item.qaLocator">
            <ng-container *ngTemplateOutlet="itemContent; context: { iconName: item.iconName, title: item.title }">
            </ng-container>
          </a>
        </ng-container>
        <ng-container *ngIf="item?.menuItem === 'purchases' && purchasesLinks | async">
          <ng-container *ngTemplateOutlet="purchases; context: { links: items?.purchaseLinks, purchases: item, menuItems: items}">
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

  </ng-container>


  <a class="account-side-bar-menu-item"
    routerLinkActive="account-side-bar-menu-item--active"
    (click)="navigateToSupport()"
    [mmTestTarget]="supportItem.qaLocator">
    <ng-container *ngTemplateOutlet="itemContent; context: { iconName: supportItem.iconName, title: supportItem.title }">
    </ng-container>
  </a>
  <a class="account-side-bar-menu-item account-side-bar-menu-item__logout" (click)="logout()"
    [mmTestTarget]="logoutItem.qaLocator">
    <ng-container *ngTemplateOutlet="itemContent; context: { iconName: logoutItem.iconName, title: logoutItem.title }">
    </ng-container>
  </a>
</div>

<ng-template #purchases let-purchases="purchases" let-links="links" let-menuItems="menuItems">
  <ng-container *ngIf="(links?.length || 0) > 0; else linkBlock">
    <button class="account-side-bar-menu-item account-side-bar-menu-item__toggle-btn"
      [mmTestTarget]="purchases.qaLocator" (click)="togglePurchasesContent(menuItems)">
      <ng-container *ngTemplateOutlet="itemContent; context: { iconName: purchases.iconName, title: purchases.title }">
      </ng-container>
      <span class="account-side-bar-menu-item__icon account-side-bar-menu-item__icon--collapsed">
        <mm-icon [name]="menuItems.isPurchasesHidden ? 'chevron-down' : 'chevron-up'"></mm-icon>
      </span>
    </button>
    <div [hidden]="menuItems.isPurchasesHidden" class="account-side-bar-menu-item__collapsed-content">
      <a *ngFor="let link of links" class="account-side-bar-menu-item" [href]="link?.url"
        (click)="sendGAEvents(link?.name,true)" [class.account-side-bar-menu-item--active]="link?.url === navigatedUrl"
        routerLinkActive="account-side-bar-menu-item--active">
        <ng-container *ngTemplateOutlet="itemContent; context: {
            title: link?.label }"></ng-container>
      </a>
    </div>
  </ng-container>
  <ng-template #linkBlock>
    <a *ngIf="!purchases.disabled" class="account-side-bar-menu-item"
      [class.account-side-bar-menu-item--active]="purchases?.link === navigatedUrl" [href]="purchases.link"
      (click)="sendGAEvents(purchases?.gaEventLabel,false)" [mmTestTarget]="purchases.qaLocator">
      <ng-container
        *ngTemplateOutlet="itemContent; context: { iconName: purchases.iconName, title: purchases.linkTitle }">
      </ng-container>
    </a>
  </ng-template>
</ng-template>

<ng-template #itemContent let-iconName="iconName" let-title="title">
  <span *ngIf="iconName" class="account-side-bar-menu-item__icon">
    <mm-icon type="fluid" [name]="iconName">
    </mm-icon>
  </span>
  <span class="account-side-bar-menu-item__title">
    {{ title | translate }}
  </span>
</ng-template>
